export default __webpack_public_path__ + "static/media/FifthView.f7e72719.jpeg";